/**
 * Quick services ("Rychlé služby") page
 *
 * Formerly "Živé relace" — a public list of currently-active live sessions.
 * The 2026-07 status meeting with Teiresiás asked for the list to go away:
 * a session in a link-reachable room could be discovered here by anyone,
 * which was never the intent ("bezpečnostně to tak ani nebylo zamýšleno…
 * aby ty živé relace nijak nezobrazovaly seznam aktuálně živých, ale bylo by
 * to opravdu jenom pro nějaké rychlé vytvoření služby. Nic víc.").
 *
 * What remains is the quick-create entry: presenters spin up a space + room +
 * stream in two clicks and share the QR. Viewers join via a direct link /
 * QR (`/join/{id}`), never via a directory.
 */

import { Monitor, Plus, QrCode } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button, EmptyState } from '../components/ui'
import { usePageTitle } from '../hooks/use-page-title'
import { useUserRole } from '../hooks/use-user-role'
import { useSession } from '../lib/auth-client'

export default function SessionsPage() {
	const { t } = useTranslation()
	usePageTitle(t('sessions.list.title'))
	const { data: session } = useSession()
	const { isPresenter } = useUserRole()

	return (
		<div className="space-y-6 animate-enter">
			<div className="flex items-start justify-between flex-wrap gap-3">
				<div>
					<h1 className="text-2xl font-display font-semibold">{t('sessions.list.title')}</h1>
					<p className="text-base-content/60 mt-1">{t('sessions.list.subtitle')}</p>
				</div>

				{session?.user && isPresenter && (
					<Link to="/sessions/create">
						<Button variant="primary" leadingIcon={<Plus size={16} />}>
							{t('sessions.list.createButton')}
						</Button>
					</Link>
				)}
			</div>

			<EmptyState
				icon={session?.user && isPresenter ? <Monitor size={32} /> : <QrCode size={32} />}
				title={t('sessions.list.empty.title')}
				description={t('sessions.list.noListHint')}
			/>
		</div>
	)
}
